import ArchiveOutlined from "@mui/icons-material/ArchiveOutlined";
import Check from "@mui/icons-material/Check";
import NotificationsActive from "@mui/icons-material/NotificationsActive";
import Subject from "@mui/icons-material/Subject";
import { ListItemIcon, Menu, MenuItem } from "@mui/material";

import type { TrayNotification } from "./NotificationTrayRow";

const MENU_PAPER = { paper: { sx: { minWidth: 260 } } };

/** The tray's "everything" actions: mark every notification read, or unread. */
export function NotificationTrayActionsMenu({
  anchorEl,
  onClose,
  canMarkAllRead,
  canMarkAllUnread,
  onMarkAllRead,
  onMarkAllUnread,
}: {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  canMarkAllRead: boolean;
  canMarkAllUnread: boolean;
  onMarkAllRead: () => void;
  onMarkAllUnread: () => void;
}) {
  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose} slotProps={MENU_PAPER}>
      <MenuItem disabled={!canMarkAllRead} onClick={onMarkAllRead}>
        <ListItemIcon>
          <Check fontSize="small" />
        </ListItemIcon>
        Mark all as read
      </MenuItem>
      <MenuItem disabled={!canMarkAllUnread} onClick={onMarkAllUnread}>
        <ListItemIcon>
          <NotificationsActive fontSize="small" />
        </ListItemIcon>
        Mark all as unread
      </MenuItem>
    </Menu>
  );
}

/** One row's actions. Disabled while its notification is gone or being updated. */
export function NotificationRowActionsMenu({
  anchorEl,
  onClose,
  notificationUser,
  updating,
  onView,
  onToggleRead,
  onArchive,
}: {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  notificationUser: TrayNotification | null;
  updating: boolean;
  onView: () => void;
  onToggleRead: () => void;
  onArchive: () => void;
}) {
  const isRead = Boolean(notificationUser?.readAt);
  const canUpdate = Boolean(notificationUser) && !updating;

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose} slotProps={MENU_PAPER}>
      <MenuItem disabled={!notificationUser} onClick={onView}>
        <ListItemIcon>
          <Subject fontSize="small" />
        </ListItemIcon>
        View notification
      </MenuItem>
      <MenuItem disabled={!canUpdate} onClick={onToggleRead}>
        <ListItemIcon>
          {isRead ? <NotificationsActive fontSize="small" /> : <Check fontSize="small" />}
        </ListItemIcon>
        {isRead ? "Mark as unread" : "Mark as read"}
      </MenuItem>
      <MenuItem disabled={!canUpdate} onClick={onArchive}>
        <ListItemIcon>
          <ArchiveOutlined fontSize="small" />
        </ListItemIcon>
        Archive
      </MenuItem>
    </Menu>
  );
}
